import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { BaseService } from "./base.service";
import { Announcer } from "../models/announcer.model";

@Injectable({
    providedIn: 'root'
})
export class AnnouncerService extends BaseService {
    controllerRoute = 'Announcement';

    constructor(httpClient: HttpClient) { 
        super(httpClient);
    }

    public async get(): Promise<Announcer[]> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}`;
        return await firstValueFrom(this.httpClient.get<Announcer[]>(url));
    }
}